import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService } from '@app/services';

class ReportsService {
    readonly apiBase: string = '/api/password-server/audit';

    userReportsLog(userId: string, reportType: string): AxiosPromise {
        return apiService
        .post(`${this.apiBase}/log?userId=${userId}&reportType=${reportType}` )
        .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getUserSeeReports(userid: string, skip: number, take: number): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/access`, {
                params: {
                    userid: userid,
                    take: take,
                    skip: skip
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getUserSeenReports(userid: string, skip: number, take: number): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/seen`, {
                params: {
                    userid: userid,
                    take: take,
                    skip: skip
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getUserStillKnowReports(userid: string, skip: number, take: number): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/knows`, {
                params: {
                    userid: userid,
                    take: take,
                    skip: skip
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }


    getUserBeenDoingLatelyReports(userid: string, skip: number, take: number): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/actions`, {
                params: {
                    userid: userid,
                    take: take,
                    skip: skip
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getUsersForReports(skip: number, take: number): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/users`, {
                params: {
                    take: take,
                    skip: skip
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }
}

export const reportsService = new ReportsService();
